import { __decorate } from "tslib";
import Avatar from "@/components/Avatar.vue";
import { Vue, Component } from "vue-property-decorator";
import { mapGetters } from "vuex";
let CompanyCard = class CompanyCard extends Vue {
    getCompany;
    get company() {
        return this.getCompany('mine');
    }
};
CompanyCard = __decorate([
    Component({
        components: { Avatar },
        computed: {
            ...mapGetters('my-company', { getCompany: 'get' })
        }
    })
], CompanyCard);
export default CompanyCard;
